import {AccessModel} from './Access.model';

export class UserOrGroupModel {
    public id: number;
    public azureObjectId: string;
    public isGroup: boolean;
    public isUser: boolean;
    public userMail: string;
    public userGivenName: string;
    public userSurname: string;
    public access: Array<AccessModel>;
    public name: string;

    public isNew: boolean;

    constructor() {
        this.access = new Array<AccessModel>();
        this.isNew=false;
    }
}
